// extracted by mini-css-extract-plugin
export var glideBullet = "glide__bullet";
export var glideBulletActive = "glide__bullet--active";
export var glideBullets = "glide__bullets";
export var glideSlide = "glide__slide";
export var root = "wr2a";